import { render, staticRenderFns } from "./RevMenuOptions.vue?vue&type=template&id=2a2ec3c4"
import script from "./RevMenuOptions.vue?vue&type=script&lang=js"
export * from "./RevMenuOptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports